import React, { createContext, useState } from "react"
const ProgressContext = createContext(undefined)
const ProgressDispatchContext = createContext(undefined)

function ContextProvider({ children }) {
  const [progressStatus, setProgressStatus] = useState({
    status: false
  })

  return (
    <ProgressContext.Provider value={progressStatus}>
      <ProgressDispatchContext.Provider value={setProgressStatus}>
        {children}
      </ProgressDispatchContext.Provider>
    </ProgressContext.Provider>
  )
}

export { ContextProvider, ProgressContext, ProgressDispatchContext }